import React from "react"
import { TabSwitch, Typography, theme } from "cdh-data-portal-theme"
import { AssignLineManagerDeputy } from "../../organisms/AssignLineManagerDeputy/AssignLineManagerDeputy"
import { RemoveLineManagerAssignments } from "../../organisms/RemoveLineManagerAssignments/RemoveLineManagerAssignments"
import { useStyles } from "./TemporaryLineManagerPage.style"
import { useTemporaryLineManagerPage } from "./TemporaryLineManagerPage.logic"
import { localtext } from "./TemporaryLineManagerPage.static"

export const TemporaryLineManagerPage: React.FC = () => {
  const { classes } = useStyles()
  const { activeTab, addAssignment, assignments, removeAssignment, setActiveTab } = useTemporaryLineManagerPage()

  return (
    <div className={classes.root}>
      <Typography variant="headline1" className={classes.title} color={theme.textColors.primary}>{localtext.Title}</Typography>
      <Typography variant="body" className={classes.subtitle} color={theme.textColors.primaryLighter}>{localtext.Subtitle}</Typography>
      <TabSwitch
        className={classes.tabs}
        tabs={[
          { title: localtext.TabAddDeputy },
          { info: assignments.length || undefined, title: localtext.TabRemoveAssignment },
        ]}
        value={activeTab}
        onChange={setActiveTab}
      />
      <div className={classes.tabContent}>
        {activeTab === 0 && <AssignLineManagerDeputy onAssignmentAdded={addAssignment} />}
        {activeTab === 1 && <RemoveLineManagerAssignments assignments={assignments} onRemove={removeAssignment} />}
      </div>
    </div>
  )
}
